import View from "../framework/view";
import template from "../../pugc/asset-manager";
import Server from "../server";
import {Asset} from "../bo/asset";
import jQuery from "jquery";

const classname = "asset-manager-view";

const server = Server.instance();

type SelectionListener = (x: Asset) => void;

export class AssetManagerView extends View {

    private assets : Asset[] = [];

    private listener : SelectionListener | undefined;

    private filter = "";

    constructor(listener?: SelectionListener) {
        super(classname);
        this.listener = listener;
        this.load();
    }

    async load() {
        this.assets = await server.assets();
        this.update();
    }

    render0() : JQuery<HTMLElement> {

        const f = this.filter.toLowerCase();
        const assets = f.length > 0 ? this.assets.filter(x => x.name && x.name.toLowerCase().indexOf(f) >= 0) : this.assets;

        const data = {
            assets: assets
        };

        const out = this.pug(template, data);

        return out;
    }

    select(idx: number) {
        if (this.listener) {
            this.listener(this.assets[idx]);
        }
    }

    async uploadImage() {
        const input = this.elt().find("input.upload") as JQuery<HTMLInputElement>;

        const file = input[0].files && input[0].files.length && input[0].files[0];

        if (! file) {
            return;
        }

        const upload = await server.uploadAsset(file);
        const assets = upload.data;
        this.assets.splice(0, 0, ...assets);
        this.update()
    }

    applyFilter() {
        this.filter = this.elt().find("input.filter").val() as string || "";
        this.update(".assets");
    }

}

View.on(
    "." + classname,
    "click",
    ".asset",
    function(that: AssetManagerView, event, elt) {
        event.preventDefault();
        event.stopImmediatePropagation();
        const idx = jQuery(elt).data("idx") as any as number;
        that.select(idx);
    });

View.on(
    "." + classname,
    "change",
    "input.upload",
    function(that: AssetManagerView, event, elt) {
        event.preventDefault();
        event.stopImmediatePropagation();
        that.uploadImage();
    });

View.on(
    "." + classname,
    "input",
    "input.filter",
    function(that: AssetManagerView, event, elt) {
        event.preventDefault();
        event.stopImmediatePropagation();
        that.applyFilter();
    });

